import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { IForm } from 'core-components/classes/models/IForm'

/*
 * todo: all dates are presented as string. needed to be converted to js Date?
 *  if so, then a new interface must be created, where dates are of type Date.
 */
export const mapRequestFromCrud = (data: IForm): IRequest => ({
  EntryId: data.EntryId || 0,
  RequestUid: data.RequestUid,
  Status: data.Status || '',
  PartnerId: data.PartnerId || '',
  PartnerName: data.PartnerName || '',
  ProcessProgress: data.ProcessProgress || '',
  RequestProgress: data.RequestProgress || 0,
  PartnerSource: data.PartnerSource || '',
  StartDate: data.StartDate,
  EndDate: data.EndDate,
  Duration: data.Duration || '',
  DDQNeeded: data.DDQNeeded || '',
  Created: data.Created || '',
  CreatedBy: data.CreatedBy || '',
  Modified: data.Modified || '',
  ModifiedBy: data.ModifiedBy || '',
  Type: data.Type || RequestTypes.Contract,
  Submitted: data.Submitted || undefined,
  Country: data.Country || '',
  CountryISO: data.CountryISO || '',
  Contract: data.Contract || '',
  Category: data.Category || 'New',
  Props: data.Props || '',
  Parent: data.Parent || null,
  Comment: data.Comment || '',
  RejectReason: data.RejectReason || '',
  RejectDate: data.RejectDate,
  Market: data.Market || '',
  Organization: data.Organization || '',
  Requestor: data.Requestor || '',
  Support: data.Support || null,
  CaseOwner: data.CaseOwner || '',
  MainParameter: data.MainParameter || '',
  ParentSpec: data.ParentSpec || '',
  RoleAccess: data.RoleAccess || '',
  Region: data.Region || '',
  ReopenDate: data.ReopenDate || '',
  TemplateUUID: data.TemplateUUID || '',
  LocationID: data.LocationID || '',
  DetailedStatus: data.DetailedStatus || '',
  TAT: data.TAT || 0,
})

export const mapRequestsFromCrud = (data: IForm[]) => data.map(mapRequestFromCrud)
